import {
    CARTDATA_UPDATE,
    HANDLE_EMAIL_CHANGE,
    SUBSCRIBE_STOCK,
    HANDLE_STOCK_SUBSCRIPTION_POPIN,
    HANDLE_STOCK_SUBSCRIPTION_SUCCESS_POPIN
} from '../actionsTypes'

const initialState = {
    consolidationMessages : null,
    email : '',
    subscribeMessage : '',
    productSellerName : null,
    showModal: '',
    openStockSubscriptionSuccessPopin: false,
    openStockSubscriptionPopin: false
};

const ProductAddToCartReducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case CARTDATA_UPDATE:
            return {
                ...state,
                consolidationMessages : action.payload.consolidationMessages,
                productSellerName : action.payload.productSellerName,
                showModal: action.payload.showModal
            }
        case HANDLE_EMAIL_CHANGE:
            return {
                ...state,
                email : action.payload.email
            }
        case SUBSCRIBE_STOCK:
            return {
                ...state,
                subscribeMessage : action.payload.subscribeMessage
            }
        case HANDLE_STOCK_SUBSCRIPTION_POPIN:
            return {
                ...state,
                openStockSubscriptionPopin : action.payload.openStockSubscriptionPopin
            }
        case HANDLE_STOCK_SUBSCRIPTION_SUCCESS_POPIN:
            return {
                ...state,
                openStockSubscriptionSuccessPopin : action.payload.openStockSubscriptionSuccessPopin
            }
        default:
            return state;
    }

};

export default ProductAddToCartReducer;